(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_dh-collection-filter"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get("collection-filters")) {
      return;
    }

    class CollectionFilters extends HTMLElement {
      constructor() {
        super();
      }

      get sectionId() {
        return this.dataset.sectionId || this.closest('[data-section-id]')?.dataset.sectionId;
      }

      connectedCallback() {
        this.filterInputs = this.querySelectorAll('input[type="checkbox"]');
        this.searchInputs = this.querySelectorAll("[data-filter-search]");
        this.filterDropdowns = this.querySelectorAll(".dh-collection-filter__container--desktop .dh-collection-filter__filter--single");
        this.mobileFilterDropdowns = this.querySelectorAll(".dh-collection-filter__container--mobile [data-mobile-filter-single]");
        this.mobileTrigger = this.querySelector("[data-mobile-filter-open]");
        this.mobileDrawer = this.querySelector("[data-mobile-filter-drawer]");
        this.mobileCloseButtons = this.querySelectorAll("[data-mobile-filter-close]");
        this.handleClick = this.handleClick.bind(this);
        this.handleFilterUrlClick = this.handleFilterUrlClick.bind(this);
        this.handleDropdownToggle = this.handleDropdownToggle.bind(this);
        this.handleFilterSearch = this.handleFilterSearch.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleDocumentKeydown = this.handleDocumentKeydown.bind(this);
        this.handleWindowResize = this.handleWindowResize.bind(this);
        this.handleMobileOpen = this.handleMobileOpen.bind(this);
        this.handleMobileClose = this.handleMobileClose.bind(this);
        this.handleMobileDropdownToggle = this.handleMobileDropdownToggle.bind(this);

        this.filterInputs.forEach((input) => {
          input.addEventListener('change', this.handleClick)
        })

        this.searchInputs.forEach((input) => {
          input.addEventListener('input', this.handleFilterSearch)
        })

        this.querySelectorAll("[data-filter-url]").forEach((button) => {
          button.addEventListener('click', this.handleFilterUrlClick)
        })

        this.filterDropdowns.forEach((dropdown) => {
          dropdown.addEventListener('toggle', this.handleDropdownToggle)
        })

        this.mobileFilterDropdowns.forEach((dropdown) => {
          dropdown.addEventListener('toggle', this.handleMobileDropdownToggle)
        })

        if (this.mobileTrigger) {
          this.mobileTrigger.addEventListener('click', this.handleMobileOpen)
        }

        this.mobileCloseButtons.forEach((button) => {
          button.addEventListener('click', this.handleMobileClose)
        })

        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleDocumentKeydown);
        window.addEventListener('resize', this.handleWindowResize);

        this.isHistoryNavigation = this.consumeHistoryNavigationFlag();
        this.syncDesktopFilterWidths();
        this.restoreDesktopFilterState();
        this.restoreMobileDrawerState();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleDocumentKeydown);
        window.removeEventListener('resize', this.handleWindowResize);

        if (this.mobileDrawerCloseTimer) {
          window.clearTimeout(this.mobileDrawerCloseTimer);
          this.mobileDrawerCloseTimer = null;
        }

        if (this.mobileDrawer && !this.mobileDrawer.hidden && window.theme?.a11y?.unlockMobileScrolling) {
          window.theme.a11y.unlockMobileScrolling(`${this.namespace}-mobile`);
        }
      }

      handleMobileOpen(event) {
        event.preventDefault();
        this.closeOpenDropdowns(false);
        this.closeOpenMobileDropdowns(null, false);
        this.openMobileDrawer();
      }

      handleMobileClose(event) {
        event.preventDefault();
        this.closeMobileDrawer();
      }

      handleMobileDropdownToggle(event) {
        const currentDropdown = event.currentTarget;

        if (!currentDropdown.open) {
          if (!this.querySelector(".dh-collection-filter__container--mobile details[open]")) {
            this.storeMobileDrawerState(null);
          }
          return;
        }

        this.closeOpenMobileDropdowns(currentDropdown);
        this.storeMobileDrawerState(currentDropdown.dataset.mobileFilterKey || null);
      }

      handleWindowResize() {
        this.syncDesktopFilterWidths();
      }

      openMobileDrawer() {
        if (!this.mobileDrawer) {
          return;
        }

        if (this.mobileDrawerCloseTimer) {
          window.clearTimeout(this.mobileDrawerCloseTimer);
          this.mobileDrawerCloseTimer = null;
        }

        this.mobileDrawer.hidden = false;
        this.mobileDrawer.classList.add("is-active");
        this.restoreMobileDrawerState();

        requestAnimationFrame(() => {
          this.mobileDrawer.classList.add("is-active");
        });

        if (window.theme?.a11y?.lockMobileScrolling) {
          window.theme.a11y.lockMobileScrolling(`${this.namespace}-mobile`);
        }
      }

      closeMobileDrawerOnLoad() {
        if (!this.mobileDrawer) {
          return;
        }

        if (this.mobileDrawerCloseTimer) {
          window.clearTimeout(this.mobileDrawerCloseTimer);
          this.mobileDrawerCloseTimer = null;
        }

        this.mobileDrawer.hidden = true;
        this.mobileDrawer.classList.remove("is-active");
        this.closeOpenMobileDropdowns(null, false);

        if (window.theme?.a11y?.unlockMobileScrolling) {
          window.theme.a11y.unlockMobileScrolling(`${this.namespace}-mobile`);
        }
      }

      closeMobileDrawer() {
        if (!this.mobileDrawer) {
          return;
        }

        if (this.mobileDrawerCloseTimer) {
          window.clearTimeout(this.mobileDrawerCloseTimer);
          this.mobileDrawerCloseTimer = null;
        }

        this.mobileDrawer.classList.remove("is-active");
        this.closeOpenMobileDropdowns(null, false);

        this.mobileDrawerCloseTimer = window.setTimeout(() => {
          if (this.mobileDrawer) {
            this.mobileDrawer.hidden = true;
          }
          this.mobileDrawerCloseTimer = null;
        }, 220);

        if (window.theme?.a11y?.unlockMobileScrolling) {
          window.theme.a11y.unlockMobileScrolling(`${this.namespace}-mobile`);
        }

        this.setMobileDrawerDismissedState();
      }

      closeOpenMobileDropdowns(exceptDropdown = null, syncState = true) {
        if (!this.mobileFilterDropdowns || !this.mobileFilterDropdowns.length) {
          return;
        }

        this.mobileFilterDropdowns.forEach((dropdown) => {
          if (dropdown !== exceptDropdown) {
            dropdown.open = false;
          }
        });
      }

      restoreMobileDrawerState() {
        if (this.isHistoryNavigation) {
          this.clearMobileDrawerState();
          this.closeMobileDrawerOnLoad();
          return;
        }

        if (!this.mobileDrawer || !this.mobileFilterDropdowns.length) {
          return;
        }

        const isSmallViewport = window.theme?.config?.bpSmall || window.matchMedia("(max-width: 768px)").matches;

        if (!isSmallViewport) {
          return;
        }

        const state = this.getMobileDrawerState();

        if (!state || !state.reopenOnLoad) {
          return;
        }

        if (state.dismissedOnLoad) {
          this.clearMobileDrawerState();
          return;
        }

        this.mobileDrawer.hidden = false;
        this.mobileDrawer.classList.add("is-active");
        this.closeOpenMobileDropdowns(null, false);

        if (state.openKey) {
          const target = this.querySelector(`[data-mobile-filter-key="${state.openKey}"]`);
          if (target) {
            target.open = true;
          }
        }

        if (window.theme?.a11y?.lockMobileScrolling) {
          window.theme.a11y.lockMobileScrolling(`${this.namespace}-mobile`);
        }

        this.clearMobileDrawerState();
      }

      getMobileDrawerState() {
        const storageKey = this.getMobileDrawerStorageKey();

        if (!storageKey || !window.sessionStorage) {
          return null;
        }

        try {
          const raw = window.sessionStorage.getItem(storageKey);
          return raw ? JSON.parse(raw) : null;
        } catch (error) {
          return null;
        }
      }

      storeMobileDrawerState(openKey) {
        const storageKey = this.getMobileDrawerStorageKey();

        if (!storageKey || !window.sessionStorage) {
          return;
        }

        const openDetails = this.querySelector(".dh-collection-filter__container--mobile details[open]");
        const state = {
          reopenOnLoad: true,
          dismissedOnLoad: false,
          openKey: openKey || openDetails?.dataset.mobileFilterKey || null
        };

        try {
          window.sessionStorage.setItem(storageKey, JSON.stringify(state));
        } catch (error) {
          return;
        }
      }

      clearMobileDrawerState() {
        const storageKey = this.getMobileDrawerStorageKey();

        if (!storageKey || !window.sessionStorage) {
          return;
        }

        try {
          window.sessionStorage.removeItem(storageKey);
        } catch (error) {
          return;
        }
      }

      consumeHistoryNavigationFlag() {
        if (!window.sessionStorage) {
          return false;
        }

        try {
          const flag = window.sessionStorage.getItem('dhCollectionHistoryNavigation');
          if (!flag) {
            return false;
          }

          window.sessionStorage.removeItem('dhCollectionHistoryNavigation');
          return true;
        } catch (error) {
          return false;
        }
      }

      setMobileDrawerDismissedState() {
        const storageKey = this.getMobileDrawerStorageKey();

        if (!storageKey || !window.sessionStorage) {
          return;
        }

        const state = this.getMobileDrawerState() || {};
        state.reopenOnLoad = false;
        state.dismissedOnLoad = true;

        try {
          window.sessionStorage.setItem(storageKey, JSON.stringify(state));
        } catch (error) {
          return;
        }
      }

      getMobileDrawerStorageKey() {
        if (!this.sectionId) {
          return null;
        }

        return `dhCollectionMobileFilters:${this.sectionId}`;
      }

      handleClick(event) {
        const input = event.currentTarget;
        const nextUrl = input.checked ? input.dataset.addUrl : input.dataset.removeUrl;

        this.storeDesktopFilterState();
        this.storeMobileDrawerState();
        this.renderFilterUrl(nextUrl);
      }

      handleFilterUrlClick(event) {
        event.preventDefault();

        const target = event.currentTarget;
        const isActiveFilterAction = !!target.closest(".dh-collection-filter__active");

        if (isActiveFilterAction) {
          this.clearDesktopFilterState();
          this.closeOpenDropdowns(false);
          if (this.mobileDrawer && !this.mobileDrawer.hidden) {
            this.closeMobileDrawer();
          } else {
            this.clearMobileDrawerState();
          }
        } else {
          this.storeDesktopFilterState();
          this.storeMobileDrawerState();
        }

        this.renderFilterUrl(event.currentTarget.dataset.filterUrl);
      }

      handleDropdownToggle(event) {
        const currentDropdown = event.currentTarget;

        if (!currentDropdown.open) {
          if (!this.querySelector(".dh-collection-filter__container--desktop details[open]")) {
            this.clearDesktopFilterState();
          }
          return;
        }

        this.filterDropdowns.forEach((dropdown) => {
          if (dropdown !== currentDropdown) {
            dropdown.open = false;
          }
        });
        this.syncDesktopFilterWidths();
        this.storeDesktopFilterState(currentDropdown.dataset.filterKey || null);

        const searchInput = currentDropdown.querySelector("[data-filter-search]");
        if (searchInput) {
          requestAnimationFrame(() => {
            searchInput.focus();
          });
        }
      }

      handleFilterSearch(event) {
        const searchInput = event.currentTarget;
        const query = searchInput.value.trim().toLowerCase();
        const optionsContainer = searchInput.closest(".dh-collection-filter__filter--options")
          || searchInput.closest(".dh-collection-filter__mobile-filter-content");

        if (!optionsContainer) {
          return;
        }

        optionsContainer.querySelectorAll("[data-filter-option]").forEach((option) => {
          const optionLabel = option.dataset.filterOptionLabel || "";
          option.classList.toggle("is-search-hidden", query !== "" && !optionLabel.includes(query));
        });
      }

      handleDocumentClick(event) {
        const activeFilters = this.querySelector(".dh-collection-filter__active");
        const filterGroup = this.querySelector(".dh-collection-filter__filter--group");

        if (activeFilters && activeFilters.contains(event.target)) {
          this.closeOpenDropdowns();
          return;
        }

        if (filterGroup && filterGroup.contains(event.target)) {
          if (event.target.closest(".dh-collection-filter__filter--single")) {
            return;
          }

          this.closeOpenDropdowns();
          return;
        }

        if (this.contains(event.target)) {
          return;
        }

        this.closeOpenDropdowns();
      }

      handleDocumentKeydown(event) {
        if (event.key !== "Escape") {
          return;
        }

        if (this.mobileDrawer && !this.mobileDrawer.hidden) {
          this.closeMobileDrawer();
          return;
        }

        this.closeOpenDropdowns();
      }

      closeOpenDropdowns(syncState = true) {
        this.filterDropdowns.forEach((dropdown) => {
          dropdown.open = false;
        });

        if (syncState) {
          this.clearDesktopFilterState();
        }
      }

      syncDesktopFilterWidths() {
        if (!this.filterDropdowns || !this.filterDropdowns.length) {
          return;
        }

        this.filterDropdowns.forEach((dropdown) => {
          const summary = dropdown.querySelector('.dh-collection-filter__filter--label');

          if (!summary) {
            return;
          }

          const headerWidth = Math.ceil(summary.getBoundingClientRect().width);

          if (headerWidth > 0) {
            dropdown.style.setProperty('--dh-collection-filter-header-width', `${headerWidth}px`);
          } else {
            dropdown.style.removeProperty('--dh-collection-filter-header-width');
          }
        });
      }

      renderFilterUrl(nextUrl) {
        if (!nextUrl || !this.sectionId) {
          return;
        }

        const desktopState = this.getDesktopFilterState();
        const url = new URL(nextUrl, window.location.origin);
        const fetchUrl = new URL(url);

        fetchUrl.searchParams.set("section_id", this.sectionId);

        fetch(fetchUrl.toString())
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Collection filter request failed: ${response.status}`);
          }

          return response.text();
        })
        .then((html) => {
          const newDom = new DOMParser().parseFromString(html, 'text/html');
          const nextContent = newDom.getElementById('CollectionAjaxContent');
          const currentContent = document.getElementById('CollectionAjaxContent');

          if (!nextContent || !currentContent) {
            return;
          }

          if (desktopState && desktopState.openKey) {
            const openDropdown = nextContent.querySelector(`[data-filter-key="${desktopState.openKey}"]`);
            if (openDropdown) {
              openDropdown.open = true;
            }
          }

          currentContent.innerHTML = nextContent.innerHTML;
          window.history.pushState({}, "", url.toString());

          if (window.theme?.sections?.reinit) {
            window.theme.sections.reinit('collection-template');
          }

          if (window.theme?.reinitProductGridItem) {
            window.theme.reinitProductGridItem();
          }
        })
        .catch((error) => {
          console.error(error);
        });
      }

      restoreDesktopFilterState() {
        if (this.isHistoryNavigation) {
          this.clearDesktopFilterState();
          this.closeOpenDropdowns(false);
          return;
        }

        if (!this.filterDropdowns || !this.filterDropdowns.length) {
          return;
        }

        const state = this.getDesktopFilterState();

        if (!state || !state.openKey) {
          return;
        }

        const target = this.querySelector(`[data-filter-key="${state.openKey}"]`);

        if (!target) {
          this.clearDesktopFilterState();
          return;
        }

        target.open = true;
        this.clearDesktopFilterState();
      }

      getDesktopFilterStorageKey() {
        if (!this.sectionId) {
          return null;
        }

        return `dhCollectionDesktopFilters:${this.sectionId}`;
      }

      getDesktopFilterState() {
        const storageKey = this.getDesktopFilterStorageKey();

        if (!storageKey || !window.sessionStorage) {
          return null;
        }

        try {
          const raw = window.sessionStorage.getItem(storageKey);
          return raw ? JSON.parse(raw) : null;
        } catch (error) {
          return null;
        }
      }

      storeDesktopFilterState(openKey = null) {
        const storageKey = this.getDesktopFilterStorageKey();

        if (!storageKey || !window.sessionStorage) {
          return;
        }

        const openDesktop = this.querySelector(".dh-collection-filter__container--desktop details[open]");
        const state = {
          openKey: openKey || openDesktop?.dataset.filterKey || null
        };

        try {
          window.sessionStorage.setItem(storageKey, JSON.stringify(state));
        } catch (error) {
          return;
        }
      }

      clearDesktopFilterState() {
        const storageKey = this.getDesktopFilterStorageKey();

        if (!storageKey || !window.sessionStorage) {
          return;
        }

        try {
          window.sessionStorage.removeItem(storageKey);
        } catch (error) {
          return;
        }
      }
    }

    customElements.define("collection-filters", CollectionFilters);
  })();
  } catch(e) { console.error(e); }
})();

})();
